{
  "ru": {
    "passenger": {
      "documentType": {
        "id": "№ удостоверения:",
        "passport": "№ паспорта:",
        "default": "№ документа:"
      },
      "types": {
        "ADT": {
          "text": "Взрослый",
          "description": "От {min} лет и старше"
        },
        "CHD": {
          "text": "Ребенок",
          "description": "От {min} до {max} лет"
        },
        "INF": {
          "text": "Младенец",
          "description": "До {max} лет"
        },
        "YTH": {
          "text": "Молодежный",
          "description": "От {min} до {max} лет"
        }
      },
      "select": "Выбрать пассажира",
      "add": "Добавить",
      "edit": "Изменить"
    }
  },
  "kk": {
    "passenger": {
      "documentType": {
        "id": "Жеке куәлік нөмірі:",
        "passport": "Паспорт №:",
        "default": "Құжат нөмірі:"
      },
      "types": {
        "ADT": {
          "text": "Ересек",
          "description": "{min} жасқа толған"
        },
        "CHD": {
          "text": "Бала",
          "description": "{min} жастан {max} жасқа дейін"
        },
        "INF": {
          "text": "Сәби",
          "description": "{max} жасқа толмаған"
        },
        "YTH": {
          "text": "Жастар",
          "description": "{min} жастан {max} жасқа дейін"
        }
      },
      "select": "Жолаушыны таңдау",
      "add": "Қосу",
      "edit": "Өзгерту"
    }
  },
  "en": {
    "passenger": {
      "documentType": {
        "id": "Document number:",
        "passport": "Passport number:",
        "default": "Document number:"
      },
      "types": {
        "ADT": {
          "text": "Adult",
          "description": "Older than {min} years"
        },
        "CHD": {
          "text": "Child",
          "description": "Between {min} and {max} years"
        },
        "INF": {
          "text": "Infant",
          "description": "Younger than {max} years"
        },
        "YTH": {
          "text": "Youth",
          "description": "Between {min} and {max} years"
        }
      },
      "select": "Select passenger",
      "add": "Add",
      "edit": "Edit"
    }
  }
}
